import { BackendRoute } from '../config/index';
import { QueryKey } from '../constants/index';
import { ApiService } from '../services/index';
import { PageRoute } from '../types/page.types';
import { useAppMutation } from './use-app-mutation.hook';
import { useInvalidateQueries } from './use-invalidate-queries.hook';
import { useNavigate } from './use-navigate.hook';

export const useTemporaryAuthAccess = () => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.CHECK_AUTH_TEMPORARY_ACCESS);
  const navigate = useNavigate(PageRoute.MY_COMPANIES);
  const {
    mutate: grantAccess,
    isError,
    isPending,
  } = useAppMutation([QueryKey.GRANT_AUTH_TEMPORARY_ACCESS], {
    mutationFn: ({ password }: { password: string }) =>
      ApiService.post({ endpoint: BackendRoute.AUTH_TEMPORARY_ACCESS }, { body: { password } }),
    onSuccess: () => {
      navigate();
      invalidateQuery();
    },
  });

  return {
    grantAccess,
    isError,
    isPending,
  };
};
